function displayMatrix(currentID,bulkMsg,loggedin) {
  let displayGrid = document.querySelector('#matrix-grid');
  let res = variantData.find((variant) => {
    return variant.id == currentID;
  });
  let bbIcon = document.querySelector('.icon.icon-bulk-buy');
  let showPack = res['packsize'] == 1 ? false : true;
  let results;
  results = res['matrix']
  if (results != null) {
    if (!loggedin && currentCurrencyISO != 'GBP' && currentCurrencyISO != 'EUR') {
      displayGrid.textContent = bulkMsg;
    } else {
      bbIcon.classList.remove("hidden");
      let table = document.createElement('table')
      table.className = 'text-sm  text-subdued';
      table.id = 'matrix-price-table';
      let header = document.createElement('thead')
      let hrow = document.createElement('tr')
      let tcell01 = document.createElement('th')
      let tcell02 = document.createElement('th')
      let tcell03 = document.createElement('th')
      tcell01.appendChild(document.createTextNode('Quantity'))
      tcell02.appendChild(document.createTextNode('Price')) 
      hrow.appendChild(tcell01)
      hrow.appendChild(tcell02)
      hrow.appendChild(tcell03)
      if (showPack) {
        let tcell04 = document.createElement('th')
        tcell04.appendChild(document.createTextNode('Pack Price'))
        hrow.appendChild(tcell04)
      }
      header.appendChild(hrow);
      table.appendChild(header);
      let tbody = document.createElement('tbody');
      results.forEach(function (itm,i) {
        let row = document.createElement('tr');
        let cell01 = document.createElement('td')
        let cell02 = document.createElement('td')
        let cell03 = document.createElement('td')
        let price = currentCurrency.format(itm['price'] / 100)
        row.dataset.qty = itm['quantity']
        row.className = 'mouse-click'
        cell01.appendChild(document.createTextNode(itm['quantity']+' +'))
        cell02.appendChild(document.createTextNode(price))
        cell02.dataset.orgPrice = price
        cell02.className = 'price';
        let resPrice = parseFloat(res['price'] / 100);
        let itmPrice = parseFloat(itm['price'] / 100);
        let pctSaving = Math.abs( ( ( resPrice - itmPrice ) / ( ( resPrice + itmPrice ) / 2 ) ) * 100 );
        let badge = document.createElement('span')
        badge.className = 'badge';
        badge.appendChild(document.createTextNode('Save '+Math.round(pctSaving)+'%'))
        cell03.appendChild(badge);
        row.appendChild(cell01)
        row.appendChild(cell02)
        row.appendChild(cell03)
        if (showPack) {
          let cell04 = document.createElement('td');
          let pp = currentCurrency.format((itm['price'] / 100) * res['packsize']);
          cell04.appendChild(document.createTextNode(pp))
          cell04.dataset.orgPrice = pp
          cell04.className = 'price';
          row.appendChild(cell04);
        }
        tbody.appendChild(row);
      });
      table.appendChild(tbody);
      displayGrid.textContent = '';
      displayGrid.appendChild(table);
    }
  } else {
    bbIcon.classList.add("hidden");
    displayGrid.textContent = '';
  }
  let qtys = document.querySelectorAll('[data-qty]');
  qtys.forEach(function (itm,i) {
    itm.addEventListener('click', function() {
      document.querySelector('.quantity-selector input').value = itm.dataset.qty
      document.dispatchEvent(qtyChange)
      document.getElementById('rounding_msg').setAttribute('hidden','');
    });
  });
  
}

function quantityTotalCost(currentID,loggedin) {
  let qtyInput = document.querySelector('.quantity-selector input')
  if (qtyInput) {
    let qtyValue = qtyInput.value
    let qtyDisplayTotal = document.getElementById('qtyTotalCost')
    let res = variantData.find((variant) => {
      return variant.id == currentID;
    });
    let price = res['price'] / 100;
    let orgPrice = price;
    let results = res['matrix']
    if (results != null) {
      if (loggedin || currentCurrencyISO == 'GBP' || currentCurrencyISO == 'EUR') {
        results.forEach(function (itm,i) {
          let compValQty = parseInt(qtyValue)
          let compItmQty = parseInt(itm['quantity']);
          if (compValQty >= compItmQty) {
            price = itm['price'] / 100
          }
        });
      }
    }
    let sum = price * qtyValue;
    let noDiscount = orgPrice * qtyValue;
    let savings = noDiscount - sum;
    if (vatStatus) {
      price = price * vatRateSum
      sum = sum * vatRateSum
      savings = savings * vatRateSum;
    }
    formatSum = currentCurrency.format(sum)
    formatPrice = currentCurrency.format(price)
    formatSavings = currentCurrency.format(savings);
    let displaySum = document.createElement('span')
    displaySum.className = 'product-totalling'
    displaySum.appendChild(document.createTextNode('@ '+formatPrice+' = '+formatSum))
    qtyDisplayTotal.replaceChildren(displaySum);
    if (savings != 0) {
      let displaySavings = document.createElement('span')
      displaySavings.className = 'badge product-savings'
      displaySavings.appendChild(document.createTextNode('Saving '+formatSavings))
      qtyDisplayTotal.appendChild(displaySavings)
    };    
  }
}

function displayPersonalisation(currentID, currentSKU, currentTitle, currentVariantTitle, btnFull = true, btnType = 'button', btnAlignment = 'center', btnText = 'Request A Quote', btnClass = '', btnSize = '', urlIntro = '', urlBtnText = 'Discover More') {
  let output = document.createDocumentFragment();
  let res = variantData.find((variant) => {
    return variant.id == currentID;
  });
  
  if (res['personalise_data'] != null) {

    if (res['personalise_data'][0]['title'].length > 0) {
      let title = document.createComment('Personalisation Type: '+res['personalise_data'][0]['title'])
      output.appendChild(title);
    }
      
    if (res['personalise_data'][0]['intro'].length > 0) {
      let intro = fromHTML(res['personalise_data'][0]['intro'])
      output.appendChild(intro);
    }
  
    let tdTableData,tdDisplayTitle,tdTable,tdCaption,tdPara,tdSetup,tdLead,tdMinQty,tdNotes;
    if (res['personalise_data'][0]['tables'].length > 0) {
      res['personalise_data'][0]['tables'].forEach(function (tableData,i) {
        tdTableData = document.createDocumentFragment();
          tdTableData.appendChild(document.createComment(tableData['title']));
          tdDisplayTitle = document.createElement('div')
          tdDisplayTitle.className = 'table-header'
          tdDisplayTitle.appendChild(document.createTextNode(tableData['display_title']))
          tdTableData.appendChild(tdDisplayTitle);
          tdTableContainer = document.createElement('div')
          tdTableContainer.className = 'table-container'
          tdTable = document.createElement('table')
            tdCaption = document.createElement('caption')
            tdCaption.appendChild(document.createTextNode(tableData['table_caption']));
            tdTable.appendChild(tdCaption);
            let tHead = document.createElement('thead')
            let tBody = document.createElement('tbody')
            let tRow,tRow2;
            tableData['table'].forEach( function(table,rowI) {
              tRow = document.createElement('tr');
              Object.entries(table).forEach(([key, value]) => {
                if (rowI < tableData['table_hrow']) {
                  tRow2 = document.createElement('th')
                  tRow2.appendChild(document.createTextNode(value))
                  tRow.appendChild(tRow2)
                  tHead.appendChild(tRow)
                } else {
                  if (key <= tableData['table_hcol']) {
                    tRow2 = document.createElement('th')
                    tRow2.appendChild(document.createTextNode(value))
                  } else {
                    tRow2 = document.createElement('td')
                    if (currentCurrencyISO == 'EUR') {
                      let tempfig = eurCurrency.format((value/100)*eurExchange)
                      tRow2.appendChild(document.createTextNode(tempfig));
                    } else {
                      tRow2.appendChild(document.createTextNode(gbpCurrency.format(value/100)));                      
                    }
                  }
                  tRow.appendChild(tRow2)
                  tBody.appendChild(tRow);                  
                }
              });
              tdTable.append(tHead,tBody);
            });
          tdTableContainer.appendChild(tdTable)
          tdTableData.appendChild(tdTableContainer);
          if (currentCurrencyISO == 'EUR') {
            exchangePara = document.createElement('p')
            exchangePara.append(document.createTextNode('* Estimate prices based on current exchange rate from GBP, final figure may vary.'))
            tdTableData.appendChild(exchangePara);
          } else if (currentCurrencyISO != 'GBP') {
            exchangePara = document.createElement('p')
            exchangePara.append(document.createTextNode('* Prices listed in GBP.'))
            tdTableData.appendChild(exchangePara);
          }
          tdPara = document.createElement('p');
            if (tableData['setup_fee'].length > 0) {
              tdSetup = document.createElement('strong')
              tdSetup.append(document.createTextNode('One-off Setup Fee: '))
              tdPara.append(tdSetup,document.createTextNode(tableData['setup_fee']),document.createElement('br'));
            }
            if (tableData['lead_time'].length > 0) {
              tdLead = document.createElement('strong')
              tdLead.append(document.createTextNode('Lead Time: '))
              tdPara.append(tdLead,document.createTextNode(tableData['lead_time']),document.createElement('br'));
            }
            if (tableData['min_qty'].length > 0) {
              tdMinQty = document.createElement('strong')
              tdMinQty.append(document.createTextNode('Minimum Order Quantity: '))
              tdPara.append(tdMinQty,document.createTextNode(tableData['min_qty']),document.createElement('br'));
            }
            if (tableData['notes'].length > 0) {
              tdNotes = fromHTML(tableData['notes'])
              tdPara.appendChild(tdNotes);
            }
          tdTableData.appendChild(tdPara);
        
        output.appendChild(tdTableData);
      });
    }

    if (res['personalise_data'][0]['outro'].length > 0) {
      let outro = fromHTML(res['personalise_data'][0]['outro'])
      output.appendChild(outro);
    }
      
    if (res['personalise_data'][0]['formid']) {
      
      let buttonWrapper = document.createElement('div') 
      buttonWrapper.classList.add('v-stack','text-center');
      const button = document.createElement('button')
      button.dataset.tallyOpen = res['personalise_data'][0]['formid']
      button.dataset.tallyLayout = 'modal'
      button.dataset.tallyWidth = '480'
      button.dataset.sku = currentSKU
      button.dataset.productName = `${currentTitle} - ${currentVariantTitle}`;
      button.setAttribute('title',btnText)
      button.classList.add('button')
      button.appendChild(document.createTextNode(btnText))
      buttonWrapper.appendChild(button)
      output.appendChild(buttonWrapper);
    }
    
    if (res['personalise_data'][0]['url']) {
      let buttonWrapper = document.createElement('div');
      if (btnFull && btnType == 'button') {
        buttonWrapper.classList.add('v-stack')
      }
      if (btnAlignment == 'left') {
        buttonWrapper.classList.add('text-start')
      } else if (btnAlignment == 'right') {
        buttonWrapper.classList.add('text-end')
      } else if (btnAlignment == 'center') {
        buttonWrapper.classList.add('text-center')
      }
    
      let button = document.createElement('a')
      button.setAttribute('title',urlBtnText)
      if (btnType == 'button') {
        button.classList.add('button')
        if (btnClass.length > 0) {
          button.classList.add(btnClass)
        }
        if (btnSize.length > 0) {
          button.classList.add(btnSize)
        }
      } else {
        button.classList.add('link')
      }
      button.href = res['personalise_data'][0]['url']
      button.appendChild(document.createTextNode(urlBtnText))
      buttonWrapper.appendChild(button)
      output.appendChild(buttonWrapper);
    }
    
    return output;
  
  } else {
    return false;
  }
}

function fromHTML(html, trim = true) {
  // Process the HTML string.
  html = trim ? html.trim() : html;
  if (!html) return null;

  let template = document.createElement('template');
  template.innerHTML = html;
  let result = template.content.children;

  // Then return either an HTMLElement or HTMLCollection,
  // based on whether the input HTML had one or more roots.
  if (result.length === 1) return result[0];
  return result;
}

const replacedByDisplay = document.querySelector('#replaced_by');
if (replacedByDisplay) {
  document.addEventListener('variant:change', function(event) {
    const currentID = event.detail.variant.id
    let showReplacedBy = false;
    replacedByDisplay.querySelectorAll('[data-replaced-by-item]').forEach((el, index) => {
      if (el.dataset.variantId == currentID) {
        el.removeAttribute('hidden')
        showReplacedBy = true
      } else {
        el.setAttribute('hidden',true)
      }
    });
    if (showReplacedBy) {
      replacedByDisplay.removeAttribute('hidden')
    } else {      
      replacedByDisplay.setAttribute('hidden',true)
    }
  });
};